import ContentScreen from '@/components/ContentScreen';
import Loader from '@/components/Loader';
import { ApplicationState } from '@/store';
import { getFavoriteListRequest } from '@/store/favorite/actions';
import { getContentRequest } from '@/store/item/action';
import { ContentStudentViewRequest } from '@/store/item/types';
import { getCourseRequest } from '@/store/list/action';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import PageNotFound from '../PageNotFound/PageNotFound';
import './style.scss';

const ContentPage: React.FC = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const { id, courseId } = useParams<{ id: string; courseId: string }>();

    const { content, personId, loading, hasError, myCurrentCourse } = useSelector((state: ApplicationState) => ({
        personId: state.identity.data.person.id,
        content: state.itens.currentData.content,
        loading: state.itens.loading,
        hasError: state.itens.hasError,
        myCurrentCourse: state.lists.courseData,
    }));

    const [hasContent, setHasContent] = useState<boolean>(false);

    const fromSuggestedContentPreview = history.location.pathname.indexOf('/mine/') > -1;

    useEffect(() => {
        if (fromSuggestedContentPreview && !myCurrentCourse.id) {
            dispatch(getCourseRequest(parseInt(courseId)));
        }
    }, [myCurrentCourse.id]);

    useEffect(() => {
        dispatch(
            getContentRequest({
                personId,
                contentId: parseInt(id || '0'),
                locale: fromSuggestedContentPreview ? myCurrentCourse.locale : undefined,
            } as ContentStudentViewRequest),
        );
        dispatch(getFavoriteListRequest());
    }, [dispatch, id, personId, myCurrentCourse]);

    useEffect(() => {
        if (content) {
            setHasContent(true);
        }
    }, [content]);

    return (
        <>
            {loading && <Loader />}
            {!loading && hasContent && <ContentScreen />}
            {!loading && hasError && <PageNotFound />}
        </>
    );
};
export default ContentPage;
